import { borderRadius, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const AlertsIconRoot = styled.div`
  position: relative;
  padding-top: 4px;
`;

export const UnreadBadge = styled.span`
  position: absolute;
  left: 16px;
  bottom: 19px;
  width: 18px;
  height: 18px;
  ${borderRadius.rFull};
  background: var(--surface-primary);
  color: var(--text-on-primary);
  display: flex;
  align-items: center;
  justify-content: center;
  ${typographyV2.bodyXs};
`;
